export const styles = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  loader: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    filter: "blur(1.1px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }
}
